import { useLanguage, LanguageCode } from "@/contexts/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

const languageFlags: Record<LanguageCode, string> = {
  nl: "🇳🇱",
  en: "🇬🇧",
  fr: "🇫🇷",
};

export const LanguageSwitcher = () => {
  const { currentLanguage, languages, setLanguage, isLoading } = useLanguage();

  if (isLoading) {
    return (
      <Button variant="ghost" size="sm" disabled>
        <Globe className="h-4 w-4" />
      </Button>
    );
  }

  const currentLang = languages.find((l) => l.code === currentLanguage);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <span className="text-lg">{languageFlags[currentLanguage]}</span>
          <span className="hidden sm:inline">{currentLang?.native_name || currentLanguage.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code as LanguageCode)}
            className={currentLanguage === lang.code ? "bg-accent" : ""}
          >
            <span className="text-lg mr-2">{languageFlags[lang.code as LanguageCode]}</span>
            {lang.native_name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
